import { Button, ConfigProvider, Flex, Layout, Row, Space, Tabs } from "antd";



import { Select } from "components/form";
import { FormDatePicker } from 'components/form/FormProvide';
import PayrollPeriodTable from 'components/table/PayrollPeriodTable';
import dayjs from "dayjs";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import styles from "../styles/PayrollPeriod.module.css";
import CreateSpecialModal from "./PayrollModal/CreateSpecialModal";
import PayrollPeriodOngoing from "./PayrollPeriodOngoing";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import CreateSpecialPeriodModal from "./PayrollModal/CreateSpecialPeriodModal";
import { useLocation } from "react-router-dom";

const PayrollPeriodMenu = ({
    payrollPerMonth = [],
    setPayrollPerMonthList = () => { },
    handleVisible = () => { },
    visible,
    isModalOpen = false,
    getPayrollPerMonth = () => { },
    payrollPeriodList = [],
    isLoading = true,
    incomeForSpecialPeriod = [],
    deductionForSpecialPeriod = [],
    payrollPeriodListPage = {},
    pagination = {},
    isModalOpenPerMonth = false,
    setModalOpenPerMonth = () => { },
    getPayrollPeriodListPage = () => { },
    setYear = () => { },
    setMonth = () => { },
    setStatusFlag = () => { },
    onCancelPerMonth = () => { },
    setModalOpen = () => { },
    getPayrollPeriodList = () => { },
    getSPecialPeriodDropdown = () => { },
    specialPeriodDropdown = () => { },
    onCreateSpecial = () => { },
    onPayrollClick = () => { },
    setActiveTab = () => { },
    getPayrollPeriodDetails = () => { },
    onViewPayrollPeriodCalculateDetails = () => { },
    getPayrollPeriodCalculateDetailsModal = () => { },
    permissions,
    isSpecialPeriodModalOpen = false,
    setIsSpecialPeriodModalOpen = () => { },
    employmentTypeDropdown = [],
    onCreateSpecialSubmit = () => { },
    updatePeriodOptions = () => { }

}) => {
    const { t } = useTranslation();
    const { Header, Content } = Layout;
    const location = useLocation();

    const MENU = [
        {
            label: t("payroll.onGoing"),
            key: "payrollOngoing"
        },
        {
            label: t("payroll.all"),
            key: "payrollAll"
        }
    ]

    const initialTab = location.state?.activeTab || "payrollOngoing";

    return (
        <Space style={{ width: "100%" }} direction="vertical" size={24}>
            <CreateSpecialPeriodModal
                isSpecialPeriodModalOpen={isSpecialPeriodModalOpen}
                setIsSpecialPeriodModalOpen={setIsSpecialPeriodModalOpen}
                employmentTypeDropdown={employmentTypeDropdown()}
                onCreateSpecialSubmit={onCreateSpecialSubmit}
                updatePeriodOptions={updatePeriodOptions}
            />
            <Formik
                enableReinitialize
                initialValues={{
                    renderTab: initialTab,
                    year: dayjs().format("YYYY")
                }}>
                {({ values = {}, setFieldValue }) => {
                    return (
                        <>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Tabs: {
                                            itemHoverColor: "var(--tab-color)",
                                            itemActiveColor: "var(--tab-color)"
                                        },
                                    },
                                }}
                            >
                                <Tabs items={MENU} activeKey={values.renderTab} defalut={MENU[0]} onChange={(e) => {
                                    setFieldValue("renderTab", e)
                                    setActiveTab(e);
                                    handleVisible(false)
                                    setMonth(null)

                                    if (e === 'payrollAll') {
                                        getPayrollPeriodList()
                                    } else if (e === 'payrollOngoing') {
                                        getPayrollPeriodListPage()
                                    }
                                }} />
                            </ConfigProvider>

                            <Flex vertical gap={16}>
                                {values.renderTab === 'payrollOngoing' && (
                                    <Flex justify="end">
                                        <Button
                                            onClick={() => {
                                                setIsSpecialPeriodModalOpen(true);
                                            }}
                                            style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", border: "none" }}
                                            type="primary"
                                            size="large"
                                        >
                                            <Flex align="center" justify="center" gap={8}>
                                                <CreateIcon />
                                                {t("payroll.create_special_period")}
                                            </Flex>
                                        </Button>
                                    </Flex>
                                )}

                                <Flex gap={10} justify="end">
                                    <FormDatePicker
                                        name="year"
                                        className={styles.selectcustom}
                                        size="large"
                                        style={{
                                            width: 120,
                                            borderRadius: "10px !important",
                                        }}
                                        picker='year'
                                        dateFormat={"YYYY"}
                                        popupMatchSelectWidth={false}
                                        value={values.year}
                                        defaultValue={dayjs()}
                                        minDate={dayjs().add(-5, 'year')}
                                        maxDate={dayjs().add(5, 'year')}
                                        onChange={(e) => {
                                            getPayrollPeriodList({ changeYear: e })
                                            console.log("e", e.year());
                                            setYear(e.year())
                                            setFieldValue('year', e)
                                        }}
                                        placeholder={t("payroll.year")}
                                    />

                                    {values.renderTab === 'payrollOngoing' && (
                                        <><FormDatePicker
                                            name="month"
                                            className={styles.selectcustom}
                                            size="large"
                                            style={{
                                                width: 120,
                                                borderRadius: "10px !important",
                                            }}
                                            picker='month'
                                            dateFormat={"MMMM"}
                                            popupMatchSelectWidth={false}
                                            value={values.month}
                                            defaultValue={null}
                                            allowClear={true}
                                            // minDate={dayjs().add(-5, 'year')}
                                            // maxDate={dayjs().add(5, 'year')}
                                            onChange={(e) => {
                                                // getPayrollPeriodList({ changeYear: e })
                                                console.log("e", e);
                                                setMonth(e?.month() + 1);
                                                setFieldValue('month', e);
                                            }}
                                            placeholder={t("payroll.month")} /><Select
                                                name="status"
                                                className={styles.selectcustom}
                                                size="large"
                                                style={{
                                                    width: 120,
                                                }}
                                                onChange={(e) => {
                                                    console.log("e", e);

                                                    setStatusFlag(e);
                                                }}
                                                popupMatchSelectWidth={false}
                                                placeholder={t("payroll.status")}
                                                options={[
                                                    {
                                                        value: 'PENDING_CALCULATION',
                                                        label: t('payroll.label.pending-calculation'),
                                                    },
                                                    {
                                                        value: 'PENDING_VERIFICATION',
                                                        label: t('payroll.label.wait-for-verify')
                                                    },
                                                    {
                                                        value: 'PENDING_APPROVAL',
                                                        label: t('payroll.label.wait-for-approve')
                                                    },
                                                    // {
                                                    //     value: 'wait for the payment period',
                                                    //     label: t('payroll.label.wait-for-the-payment-period'),
                                                    // },
                                                    {
                                                        value: 'PENDING_CLOSE',
                                                        label: t('payroll.label.waiting-for-the-period-to-close')
                                                    },
                                                    {
                                                        value: 'PENDING_PAYMENT',
                                                        label: t('payroll.label.waiting-for-payment')
                                                    }
                                                ]} /></>
                                    )}

                                    <Button
                                        size="large"
                                        style={{ borderRadius: "10px" }}
                                        onClick={() => {
                                            handleVisible(!visible)
                                        }}
                                        disabled={!permissions?.VISIBLE}
                                    >
                                        {visible ? <EyeHideIcon /> : <EyeIcon />}
                                    </Button>
                                </Flex>
                            </Flex>

                            <Content>
                                <Space style={{ width: "100%" }} direction="vertical" size={24}>
                                    {values.renderTab === 'payrollAll' ? (
                                        <PayrollPeriodTable
                                            payrollPerMonth={payrollPerMonth}
                                            setPayrollPerMonthList={setPayrollPerMonthList}
                                            getPayrollPerMonth={getPayrollPerMonth}
                                            onCancelPerMonth={onCancelPerMonth}
                                            isModalOpenPerMonth={isModalOpenPerMonth}
                                            setModalOpenPerMonth={setModalOpenPerMonth}
                                            visible={visible}
                                            payrollPeriodList={payrollPeriodList}
                                            isLoading={isLoading}
                                            getPayrollPeriodList={getPayrollPeriodList}
                                            getPayrollPeriodDetails={getPayrollPeriodDetails}
                                            onViewPayrollPeriodCalculateDetails={onViewPayrollPeriodCalculateDetails}
                                            getPayrollPeriodCalculateDetailsModal={getPayrollPeriodCalculateDetailsModal}
                                            permissions={permissions}
                                        />
                                    ) : values.renderTab === 'payrollOngoing' ? (
                                        <PayrollPeriodOngoing
                                            onPayrollClick={onPayrollClick}
                                            visible={visible}
                                            payrollPeriodList={payrollPeriodListPage}
                                            getPayrollPeriodList={getPayrollPeriodListPage}
                                            pagination={pagination}
                                            permissions={permissions}
                                        />
                                    ) : null}
                                </Space>

                            </Content>
                        </>
                    )
                }}
            </Formik>
            <CreateSpecialModal
                isModalOpen={isModalOpen}
                onCancel={() => setModalOpen(false)}
                onCreateSpecial={onCreateSpecial}
                specialPeriodDropdown={specialPeriodDropdown}
                getSPecialPeriodDropdown={getSPecialPeriodDropdown}
                incomeForSpecialPeriod={incomeForSpecialPeriod}
                deductionForSpecialPeriod={deductionForSpecialPeriod}
            />


        </Space>
    )
}

export default PayrollPeriodMenu;